export const truncate = (value: string, truncateMiddle: boolean | number) => {
  if (!truncateMiddle) return value
  const chars = typeof truncateMiddle === 'number' ? truncateMiddle : 10
  const hasHexPrefix = value.startsWith('0x')
  const body = hasHexPrefix ? value.slice(2) : value
  if (body.length <= chars * 2 + 3) return value
  const prefix = hasHexPrefix ? '0x' : ''
  return `${prefix}${body.slice(0, chars)}...${body.slice(-chars)}`
}
